import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { AdvisorCompany } from '../models/advisor-company.model';

export interface RenameAdvisorCompanyArg {
    id: string;
    name: string;
}

export const RenameAdvisorCompany = createAsyncThunk(
    'advisorCompanies/rename',
    async (arg: RenameAdvisorCompanyArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.put(
            `api/marketplace/advisor-companies/${arg.id}/name`,
            { name: arg.name }
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while renaming the advisor company.';
            createNotification(message, 'error');
            throw new Error('Failed to rename advisor company');
        }

        createNotification('Advisor company renamed.', 'success');
        return response.data as AdvisorCompany;
    }
);
